/**
 * Project capability vocabulary.
 *
 * It lives in `shared/` rather than in `pages/projects/utils.ts` because `contexts/AuthContext`
 * derives integration access from `type`, and a context must not depend on a page module.
 */
export const PROJECT_TYPE = {
  INTEGRATION: 'INTEGRATION',
  CRM: 'CRM',
  FINANCE: 'FINANCE',
  HR: 'HR',
  OTHER: 'OTHER',
} as const;

export type ProjectType = (typeof PROJECT_TYPE)[keyof typeof PROJECT_TYPE];
